export const CONTACT_BRIEFING_TAB_PARAM_KEY = "tab";
export const CONTACT_BRIEFING_RADAR_TAB_PARAM_VALUE = "radar-signals";

export const getContactRadarSignalsPath = (contactId: string): string =>
  `/contacts/${contactId}?${CONTACT_BRIEFING_TAB_PARAM_KEY}=${CONTACT_BRIEFING_RADAR_TAB_PARAM_VALUE}`;

export const PROFILE_REVIEW_PATH = "/contacts/profile-review";

export type ContactBriefingLocationState = { backTo: string };

export const getContactBriefingBackTo = (state: unknown): string => {
  const backTo =
    state instanceof Object && "backTo" in state ? state.backTo : undefined;
  return typeof backTo === "string" &&
    backTo.startsWith("/") &&
    !backTo.startsWith("//")
    ? backTo
    : "/contacts";
};
